import UserPermissionsPage from './index.vue'
export { UserPermissionsPage }
export default UserPermissionsPage
